import React from 'react';
import { Grid } from '@material-ui/core';
import { ArticleCard } from '@hydra/common/components';
import blogArticles from '@hydra/utils/blogArticles';

export function ResourcesBlogArticleCards () {
  return (
    <Grid container spacing={3}>
      {
      blogArticles.map(({ img, title, subtitle, cta, href }, index: number) => (
        <ArticleCard
          key={index}
          img={img}
          title={title}
          subtitle={subtitle}
          cta={cta}
          href={href}
        />
      ))
      }
    </Grid>
  );
}

export default ResourcesBlogArticleCards;
